var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pages-preview"},[(_vm.type == 1)?_c('iframe',{staticClass:"doc",attrs:{"src":`https://view.officeapps.live.com/op/view.aspx?src=${_vm.url}`,"frameborder":"0"}}):_vm._e(),(_vm.type == 2)?_c('iframe',{staticClass:"doc",attrs:{"src":`https://www.whtlkj.net/pdfjs/web/viewer.html?file=${_vm.url}`,"frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }